import React, { useReducer, useContext } from 'react';

import { firestoreInitialize } from 'config/firebase/client';

import OrdersContext from './OrdersContext';
import OrdersReducer from './OrdersReducer';
import AuthenticationContext from 'context/Authentication/AuthenticationContext';

const OrdersState = (props) => {
    const initialState = {
        getOrders: {
            orders: [],
            firstOrder: null,
            lastOrder: null,
            ordersFilter: [],
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        getOrdersAllMonth: {
            orders: [],
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            },
        },
        getOrdersById: {
            order: null,
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        getOrdersExcel: {
            orders: [],
            ordersFilter: [],
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        }
    };

    const [state, dispatch] = useReducer(OrdersReducer, initialState);

    const { authenticatedState } = useContext(AuthenticationContext);

    const getOrders = (type, nextPage, prevPage, firstData, lastData) => {
        dispatch({ type: 'GET_ORDERS_LOADING' });

        if (!authenticatedState.user.pais || authenticatedState.user.role === "Administrador" || authenticatedState.user.role === "Operador") {
            getGlobalOrders(type, nextPage, prevPage, firstData, lastData);
        } else {
            getOrdersPerCountry(type, nextPage, prevPage, firstData, lastData, authenticatedState.user.pais);
        }
    }

    const getGlobalOrders = (type, nextPage, prevPage, firstData, lastData) => {
        let db = firestoreInitialize();

        if (type >= 0) {
            switch (type) {
                case 0:
                    if (nextPage) {
                        db.collection('Ordenes')
                        .where('oid', '==', nextPage)
                        .orderBy('createdOn', 'desc')
                        .get()
                        .then((querySnapshot) => {
                            const dataAfter = querySnapshot.docs[0];

                            let first = db.collection("Ordenes")
                            /*.where('aliadoId', "!=", false)
                            .orderBy('aliadoId')*/
                            .orderBy('createdOn', 'desc')
                            .startAfter(dataAfter)
                            .limit(10)
            
                            first.get().then((documentSnapshots) => {
                                dispatch({ type: 'GET_ORDERS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]} });
                            })
                            .catch(error => dispatch({ type: 'GET_ORDERS_ERROR', payload: { code: 'orders/error', message: error } }))   
                        })
                        .catch((error) => dispatch({ type: 'GET_ORDERS_ERROR', payload: { code: 'orders/error', message: error } }))
                    } else if (prevPage) {
                        db.collection('Ordenes')
                        .where('oid', '==', prevPage)
                        .orderBy('createdOn', 'desc')
                        .get()
                        .then((querySnapshot) => {
                            const dataBefore = querySnapshot.docs[0];

                            let first = db.collection("Ordenes")
                            /*.where('aliadoId', "!=", false)
                            .orderBy('aliadoId')*/
                            .orderBy('createdOn', 'desc')
                            .endBefore(dataBefore)
                            .limitToLast(10);
            
                            first.get().then((documentSnapshots) => {
                                dispatch({ type: 'GET_ORDERS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]} });
                            })
                            .catch(error => dispatch({ type: 'GET_ORDERS_ERROR', payload: { code: 'orders/error', message: error } }))   
                        })
                        .catch((error) => dispatch({ type: 'GET_ORDERS_ERROR', payload: { code: 'orders/error', message: error } }))
                    } else {
                        let first = db.collection("Ordenes")
                            /*.where('aliadoId', "!=", false)
                            .orderBy('aliadoId')*/
                            .orderBy('createdOn', 'desc')
                            .limit(10)
            
                        first.get().then((documentSnapshots) => {
                            dispatch({ type: 'GET_ORDERS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]} });
                        })
                        .catch(error => dispatch({ type: 'GET_ORDERS_ERROR', payload: { code: 'orders/error', message: error } }))   
                    }
                    break;
                case 1:
                    if (nextPage) {
                        db.collection('Ordenes')
                        .where('oid', '==', nextPage)
                        .orderBy('createdOn', 'desc')
                        .get()
                        .then((querySnapshot) => {
                            const dataAfter = querySnapshot.docs[0];

                            let first = db.collection("Ordenes")
                            .where('uid', "!=", false)
                            .orderBy('uid')
                            .orderBy('createdOn', 'desc')
                            .startAfter(dataAfter)
                            .limit(10)
            
                            first.get().then((documentSnapshots) => {
                                dispatch({ type: 'GET_ORDERS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]} });
                            })
                            .catch(error => dispatch({ type: 'GET_ORDERS_ERROR', payload: { code: 'orders/error', message: error } }))   
                        })
                        .catch((error) => dispatch({ type: 'GET_ORDERS_ERROR', payload: { code: 'orders/error', message: error } }))
                    } else if (prevPage) {
                        db.collection('Ordenes')
                        .where('oid', '==', prevPage)
                        .orderBy('createdOn', 'desc')
                        .get()
                        .then((querySnapshot) => {
                            const dataBefore = querySnapshot.docs[0];

                            let first = db.collection("Ordenes")
                            .where('uid', "!=", false)
                            .orderBy('uid')
                            .orderBy('createdOn', 'desc')
                            .endBefore(dataBefore)
                            .limitToLast(10);
            
                            first.get().then((documentSnapshots) => {
                                dispatch({ type: 'GET_ORDERS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]} });
                            })
                            .catch(error => dispatch({ type: 'GET_ORDERS_ERROR', payload: { code: 'orders/error', message: error } }))   
                        })
                        .catch((error) => dispatch({ type: 'GET_ORDERS_ERROR', payload: { code: 'orders/error', message: error } }))
                    } else {
                        let first = db.collection("Ordenes")
                            .where('uid', "!=", false)
                            .orderBy('uid')
                            .orderBy('createdOn', 'desc')
                            .limit(10)
            
                        first.get().then((documentSnapshots) => {
                            dispatch({ type: 'GET_ORDERS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]} });
                        })
                        .catch(error => dispatch({ type: 'GET_ORDERS_ERROR', payload: { code: 'orders/error', message: error } }))   
                    }
                    break;
            
                default:
                    break;
            }
        } else {
            if (lastData) {
                let first = db.collection("Ordenes")
                    .orderBy('createdOn')
                    .startAfter(lastData)
                    .limit(10)
    
                first.get().then((documentSnapshots) => {
                    dispatch({ type: 'GET_ORDERS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), last: documentSnapshots.docs[documentSnapshots.docs.length-1]} });
                })
                .catch(error => dispatch({ type: 'GET_ORDERS_ERROR', payload: { code: 'orders/error', message: error } }))   
            } else {
                let first = db.collection("Ordenes")
                    .limit(10)
    
                first.get().then((documentSnapshots) => {
                    dispatch({ type: 'GET_ORDERS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), last: documentSnapshots.docs[documentSnapshots.docs.length-1]} });
                })
                .catch(error => dispatch({ type: 'GET_ORDERS_ERROR', payload: { code: 'orders/error', message: error } }))   
            }
        }
    };

    const getOrdersPerCountry = (type, nextPage, prevPage, firstData, lastData, country) => {
        let db = firestoreInitialize();

        if (type >= 0) {
            switch (type) {
                case 0:
                    if (nextPage) {
                        db.collection('Ordenes')
                        .where('oid', '==', nextPage)
                        .get()
                        .then((querySnapshot) => {
                            const dataAfter = querySnapshot.docs[0];

                            let first = db.collection("Ordenes")
                            /*.where('aliadoId', "!=", false)*/
                            .where('pais', "==", country)
                            .orderBy('createdOn', 'desc')
                            /*.orderBy('aliadoId')*/
                            .startAfter(dataAfter)
                            .limit(10)
            
                            first.get().then((documentSnapshots) => {
                                dispatch({ type: 'GET_ORDERS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]} });
                            })
                            .catch(error => dispatch({ type: 'GET_ORDERS_ERROR', payload: { code: 'orders/error', message: error } }))   
                        })
                        .catch((error) => dispatch({ type: 'GET_ORDERS_ERROR', payload: { code: 'orders/error', message: error } }))
                    } else if (prevPage) {
                        db.collection('Ordenes')
                        .where('oid', '==', prevPage)
                        .get()
                        .then((querySnapshot) => {
                            const dataBefore = querySnapshot.docs[0];

                            let first = db.collection("Ordenes")
                            /*.where('aliadoId', "!=", false)*/
                            .where('pais', "==", country)
                            /*.orderBy('aliadoId')*/
                            .orderBy('createdOn', 'desc')
                            .endBefore(dataBefore)
                            .limitToLast(10);
            
                            first.get().then((documentSnapshots) => {
                                dispatch({ type: 'GET_ORDERS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]} });
                            })
                            .catch(error => dispatch({ type: 'GET_ORDERS_ERROR', payload: { code: 'orders/error', message: error } }))   
                        })
                        .catch((error) => dispatch({ type: 'GET_ORDERS_ERROR', payload: { code: 'orders/error', message: error } }))
                    } else {
                        let first = db.collection("Ordenes")
                            /*where('aliadoId', "!=", false)*/
                            .where('pais', "==", country)
                            .orderBy('createdOn', 'desc')
                            .limit(10)
            
                        first.get().then((documentSnapshots) => {
                            dispatch({ type: 'GET_ORDERS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]} });
                        })
                        .catch(error => dispatch({ type: 'GET_ORDERS_ERROR', payload: { code: 'orders/error', message: error } }))   
                    }
                    break;
                case 1:
                    if (nextPage) {
                        db.collection('Ordenes')
                        .where('oid', '==', nextPage)
                        .get()
                        .then((querySnapshot) => {
                            const dataAfter = querySnapshot.docs[0];

                            let first = db.collection("Ordenes")
                            .where('uid', "!=", false)
                            .where('pais', "==", country)
                            .orderBy('uid')
                            .startAfter(dataAfter)
                            .limit(10)
            
                            first.get().then((documentSnapshots) => {
                                dispatch({ type: 'GET_ORDERS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]} });
                            })
                            .catch(error => dispatch({ type: 'GET_ORDERS_ERROR', payload: { code: 'orders/error', message: error } }))   
                        })
                        .catch((error) => dispatch({ type: 'GET_ORDERS_ERROR', payload: { code: 'orders/error', message: error } }))
                    } else if (prevPage) {
                        db.collection('Ordenes')
                        .where('oid', '==', prevPage)
                        .get()
                        .then((querySnapshot) => {
                            const dataBefore = querySnapshot.docs[0];

                            let first = db.collection("Ordenes")
                            .where('uid', "!=", false)
                            .where('pais', "==", country)
                            .orderBy('uid')
                            .endBefore(dataBefore)
                            .limitToLast(10);
            
                            first.get().then((documentSnapshots) => {
                                dispatch({ type: 'GET_ORDERS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]} });
                            })
                            .catch(error => dispatch({ type: 'GET_ORDERS_ERROR', payload: { code: 'orders/error', message: error } }))   
                        })
                        .catch((error) => dispatch({ type: 'GET_ORDERS_ERROR', payload: { code: 'orders/error', message: error } }))
                    } else {
                        let first = db.collection("Ordenes")
                            .where('uid', "!=", false)
                            .where('pais', "==", country)
                            .limit(10)
            
                        first.get().then((documentSnapshots) => {
                            dispatch({ type: 'GET_ORDERS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]} });
                        })
                        .catch(error => dispatch({ type: 'GET_ORDERS_ERROR', payload: { code: 'orders/error', message: error } }))   
                    }
                    break;
            
                default:
                    break;
            }
        } else {
            if (lastData) {
                let first = db.collection("Ordenes")
                    .where('pais', "==", country)
                    .orderBy('createdOn')
                    .startAfter(lastData)
                    .limit(10)
    
                first.get().then((documentSnapshots) => {
                    dispatch({ type: 'GET_ORDERS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), last: documentSnapshots.docs[documentSnapshots.docs.length-1]} });
                })
                .catch(error => dispatch({ type: 'GET_ORDERS_ERROR', payload: { code: 'orders/error', message: error } }))   
            } else {
                let first = db.collection("Ordenes")
                    .where('pais', "==", country)
                    .limit(10)
    
                first.get().then((documentSnapshots) => {
                    dispatch({ type: 'GET_ORDERS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), last: documentSnapshots.docs[documentSnapshots.docs.length-1]} });
                })
                .catch(error => dispatch({ type: 'GET_ORDERS_ERROR', payload: { code: 'orders/error', message: error } }))   
            }
        }
    }

    const getOrdersExcel = () => {
        dispatch({ type: 'GET_ORDERS_EXCEL_LOADING' });

        if (!authenticatedState.user.pais || authenticatedState.user.role === "Administrador" || authenticatedState.user.role === "Operador") {
            getGlobalOrdersExcel();
        } else {
            getOrdersPerCountryExcel(authenticatedState.user.pais);
        }
    }

    const getGlobalOrdersExcel = () => {
        let db = firestoreInitialize();

        let first = db.collection("Ordenes")
            .orderBy('createdOn', 'desc')

            first.get().then((documentSnapshots) => {
                dispatch({ type: 'GET_ORDERS_EXCEL', payload: { data: documentSnapshots.docs.map(doc => doc.data()) } });
            })
            .catch(error => dispatch({ type: 'GET_ORDERS_EXCEL_ERROR', payload: { code: 'orders/error', message: error } }))   
    };

    const getOrdersPerCountryExcel = (country) => {
        let db = firestoreInitialize();

        let first = db.collection("Ordenes")
        .where('pais', "==", country)
        .orderBy('createdOn', 'desc')

        first.get().then((documentSnapshots) => {
            dispatch({ type: 'GET_ORDERS_EXCEL', payload: { data: documentSnapshots.docs.map(doc => doc.data()) } });
        })
        .catch(error => dispatch({ type: 'GET_ORDERS_EXCEL_ERROR', payload: { code: 'orders/error', message: error } }))   
    }


    const getOrdersById = (id) => {
        dispatch({ type: 'GET_ORDERS_BY_ID_LOADING' });

        let db = firestoreInitialize();

        db.collection('Ordenes')
        .where('oid', '==', id)
        .get()
        .then((querySnapshot) => {
            dispatch({ type: 'GET_ORDERS_BY_ID', payload: querySnapshot.docs.map(doc => doc.data())})
        })
        .catch((error) => dispatch({ type: 'GET_ORDERS_BY_ID_ERROR', payload: { code: 'order/error', message: error } }))
    };

    const getOrdersPerMonth = async (startActualDate, endActualDate, startPreviusDate, endPreviusDate) => {
        dispatch({ type: 'GET_ORDERS_BY_ID_LOADING' });

        let db = firestoreInitialize();

        let ordersActualMonth;
        let ordersPreviusMonth;

        await db.collection('Ordenes')
        .where('createdOn', '>=', new Date(startActualDate))
        .where('createdOn', '<=', new Date(endActualDate))
        .get()
        .then((documentSnapshots) => {
            ordersActualMonth = documentSnapshots.docs.map(doc => doc.data())
        })

        if (startPreviusDate !== 0 && endPreviusDate !== 0) {
            await db.collection('Ordenes')
            .where('createdOn', '>=', new Date(startPreviusDate))
            .where('createdOn', '<=', new Date(endPreviusDate))
            .get()
            .then((documentSnapshots) => {
                ordersPreviusMonth = documentSnapshots.docs.map(doc => doc.data())
            })

            dispatch({ type: 'GET_ORDERS_BY_ID', payload: { ordersActualMonth: ordersActualMonth, ordersPreviusMonth: ordersPreviusMonth } })
        } else {
            dispatch({ type: 'GET_ORDERS_BY_ID', payload: { ordersActualMonth: ordersActualMonth, ordersPreviusMonth: [] } })
        }
    };

    const getOrdersPerDate = (startActualDate, endActualDate, increases, country) => {
        dispatch({ type: 'GET_ORDERS_LOADING' });

        let db = firestoreInitialize();

        let convertActualDate = new Date(startActualDate).getTime();
        convertActualDate = convertActualDate + 86400000;
        convertActualDate = new Date(convertActualDate).setHours(0);

        let convertDate = new Date(convertActualDate);
        let startDate = new Date(convertDate.getFullYear(), convertDate.getMonth(), 1);
        let endDate = new Date(convertDate.getFullYear(), convertDate.getMonth() + 1, 0);
        endDate = endDate.setHours(23,59,59,999)

        let first = db.collection("Ordenes")
            .where('createdOn', '>=', new Date(startDate))
            .where('createdOn', '<=', new Date(endDate))

        first.get().then((documentSnapshots) => {
            let ordersPerMonth = documentSnapshots.docs.map(doc => doc.data());
            ordersPerMonth = ordersPerMonth.filter(increase => increase.pais === country);

            if (increases) {
                let ordersIncreases = documentSnapshots.docs.map(doc => doc.data());
                ordersIncreases = ordersIncreases.filter(increase => increase.pais === country);
                ordersIncreases = ordersIncreases.filter(increase => increase.status === 'Confirmada');

                dispatch({ type: 'GET_ORDERS', payload: { data: { perMonth: ordersPerMonth, increases: ordersIncreases }, first: null, last: null} });
            } else {
                dispatch({ type: 'GET_ORDERS', payload: { data: { perMonth: ordersPerMonth }, first: null, last: null} });
            }
        })
        .catch(error => dispatch({ type: 'GET_ORDERS_ERROR', payload: { code: 'orders/error', message: error } }))   
    };

    const getOrdersFilter = (type, dateSince, dateUntil, status, typeOrder, country, page) => {
        dispatch({ type: 'GET_ORDERS_FILTER_LOADING' });

        if (!authenticatedState.user.pais || authenticatedState.user.role === "Administrador" || authenticatedState.user.role === "Operador") {
            getGlobalOrdersFilter(type, dateSince, dateUntil, status, typeOrder, country, page);
        } else {
            getOrdersFilterPerCountry(type, dateSince, dateUntil, status, typeOrder, page, authenticatedState.user.pais);
        }
    }

    const getGlobalOrdersFilter = (type, dateSince, dateUntil, status, typeOrder, country, page) => {
        let db = firestoreInitialize();

        if (type === 0) {
            if (dateSince && dateUntil) {
                let convertDateSince = new Date(dateSince).getTime();
                convertDateSince = convertDateSince + 86400000;
                convertDateSince = new Date(convertDateSince).setHours(0);

                let convertDateUntil = new Date(dateUntil).getTime();
                convertDateUntil = convertDateUntil + 86400000;

                let first = db.collection("Ordenes")
                .where('createdOn', ">=", new Date(convertDateSince))
                .where('createdOn', '<=', new Date(convertDateUntil))
                .orderBy('createdOn', 'desc')

            first.get().then((documentSnapshots) => {
                let orders = documentSnapshots.docs.map(doc => doc.data())

                let nextPage;

                if (status) {
                    orders = orders.filter(order => order.status === status);
                } 

                if (typeOrder) {
                    orders = orders.filter(order => order.tipoOrden === typeOrder);
                };

                if (country) {
                    orders = orders.filter(order => order.pais === country);
                }

                if (page === '1') {
                    orders = orders.slice(0, 10);
                } else {
                    nextPage = `${page}0`;
                    orders = orders.slice(parseInt(nextPage) - 10, parseInt(nextPage));
                }

                dispatch({ type: 'GET_ORDERS_FILTER', payload: { data: orders, first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1] } })
                })
                .catch(error => dispatch({ type: 'GET_ORDERS_FILTER_ERROR', payload: { code: 'orders/error', message: error } }))   
            } else {
                let first = db.collection("Ordenes")
                .where('aliadoId', "!=", false)
                .orderBy('aliadoId')

                first.get().then((documentSnapshots) => {
                    let orders = documentSnapshots.docs.map(doc => doc.data())

                    let nextPage;
            
                    if (status) {
                        orders = orders.filter(order => order.status === status);
                    }

                    if (typeOrder) {
                        orders = orders.filter(order => order.tipoOrden === typeOrder);
                    };

                    if (country) {
                        orders = orders.filter(order => order.pais === country);
                    }

                    if (page === '1') {
                        orders = orders.slice(0, 10);
                    } else {
                        nextPage = `${page}0`;
                        orders = orders.slice(parseInt(nextPage) - 10, parseInt(nextPage));
                    }
            
                    dispatch({ type: 'GET_ORDERS_FILTER', payload: { data: orders, first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1] } })
                })
                .catch(error => dispatch({ type: 'GET_ORDERS_FILTER_ERROR', payload: { code: 'orders/error', message: error } }))   
            }
        } else {
            if (dateSince && dateUntil) {
                let convertDateSince = new Date(dateSince).getTime();
                convertDateSince = convertDateSince + 86400000;
                convertDateSince = new Date(convertDateSince).setHours(0);

                let convertDateUntil = new Date(dateUntil).getTime();
                convertDateUntil = convertDateUntil + 86400000;
                convertDateUntil = new Date(convertDateUntil)

                let first = db.collection("Ordenes")
                .where('createdOn', ">=", new Date(convertDateSince))
                .where('createdOn', '<=', new Date(convertDateUntil))
                .orderBy('createdOn', 'desc')

                first.get().then((documentSnapshots) => {
                    let orders = documentSnapshots.docs.map(doc => doc.data())

                let nextPage;

                if (status) {
                    orders = orders.filter(order => order.status === status);
                } 

                if (typeOrder) {
                    orders = orders.filter(order => order.tipoOrden === typeOrder);
                };

                if (country) {
                    orders = orders.filter(order => order.pais === country);
                }

                if (page === '1') {
                    orders = orders.slice(0, 10);
                } else {
                    nextPage = `${page}0`;
                    orders = orders.slice(parseInt(nextPage) - 10, parseInt(nextPage));
                }

                dispatch({ type: 'GET_ORDERS_FILTER', payload: { data: orders, first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1] } })
                })
                .catch(error => dispatch({ type: 'GET_ORDERS_FILTER_ERROR', payload: { code: 'orders/error', message: error } }))   
            } else {
                let first = db.collection("Ordenes")
                .where('uid', "!=", false)

                first.get().then((documentSnapshots) => {
                    let orders = documentSnapshots.docs.map(doc => doc.data())

                    let nextPage;
            
                    if (status) {
                        orders = orders.filter(order => order.status === status);
                    }

                    if (typeOrder) {
                        orders = orders.filter(order => order.tipoOrden === typeOrder);
                    };

                    if (country) {
                        orders = orders.filter(order => order.pais === country);
                    }

                    if (page === '1') {
                        orders = orders.slice(0, 10);
                    } else {
                        nextPage = `${page}0`;
                        orders = orders.slice(parseInt(nextPage) - 10, parseInt(nextPage));
                    }
            
                    dispatch({ type: 'GET_ORDERS_FILTER', payload: { data: orders, first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1] } })
                })
                .catch(error => dispatch({ type: 'GET_ORDERS_FILTER_ERROR', payload: { code: 'orders/error', message: error } }))   
            };
        }
    };

    const getOrdersFilterPerCountry = (type, dateSince, dateUntil, status, typeOrder, page, country) => {
        let db = firestoreInitialize();

        if (type === 0) {
            if (dateSince && dateUntil) {
                let convertDateSince = new Date(dateSince).getTime();
                convertDateSince = convertDateSince + 86400000;
                convertDateSince = new Date(convertDateSince).setHours(0);

                let convertDateUntil = new Date(dateUntil).getTime();
                convertDateUntil = convertDateUntil + 86400000;

                let first = db.collection("Ordenes")
                .where('createdOn', ">=", new Date(convertDateSince))
                .where('createdOn', '<=', new Date(convertDateUntil))
                .where('pais', '==', country)
                .orderBy('createdOn', 'desc')

            first.get().then((documentSnapshots) => {
                const dataFetch = documentSnapshots.docs.map(doc => doc.data())

                let newData = [];
                let nextPage;
                
                newData = dataFetch;

                if (status) {
                    newData = newData.filter(newData => newData.status === status);

                    if (typeOrder) {
                        newData = newData.filter(newData => newData.tipoOrden === typeOrder);
                    };
                } else if (typeOrder) {
                    newData = dataFetch.filter(dataFetch => dataFetch.tipoOrden === typeOrder)
                }
                if (page === '1') {
                    newData = newData.slice(0, 10);
                } else {
                    nextPage = `${page}0`;
                    newData = newData.slice(parseInt(nextPage) - 10, parseInt(nextPage));
                }

                dispatch({ type: 'GET_ORDERS_FILTER', payload: { data: newData, first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1] } })
                })
                .catch(error => dispatch({ type: 'GET_ORDERS_FILTER_ERROR', payload: { code: 'orders/error', message: error } }))   
            } else {
                let first = db.collection("Ordenes")
                .where('aliadoId', "!=", false)
                .where('pais', '==', country)
                .orderBy('aliadoId')

                first.get().then((documentSnapshots) => {
                    const dataFetch = documentSnapshots.docs.map(doc => doc.data())

                    let newData = [];
                    let nextPage;
            
                    if (status) {
                        newData = dataFetch.filter(dataFetch => dataFetch.status === status);

                        if (typeOrder) {
                            newData = newData.filter(newData => newData.tipoOrden === typeOrder);
                        };
                    } else if (typeOrder) {
                        newData = dataFetch.filter(dataFetch => dataFetch.tipoOrden === typeOrder)
                    }
                    if (page === '1') {
                        newData = newData.slice(0, 10);
                    } else {
                        nextPage = `${page}0`;
                        newData = newData.slice(parseInt(nextPage) - 10, parseInt(nextPage));
                    }
            
                    dispatch({ type: 'GET_ORDERS_FILTER', payload: { data: newData, first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1] } })
                })
                .catch(error => dispatch({ type: 'GET_ORDERS_FILTER_ERROR', payload: { code: 'orders/error', message: error } }))   
            }
        } else {
            if (dateSince && dateUntil) {
                let convertDateSince = new Date(dateSince).getTime();
                convertDateSince = convertDateSince + 86400000;
                convertDateSince = new Date(convertDateSince).setHours(0);

                let convertDateUntil = new Date(dateUntil).getTime();
                convertDateUntil = convertDateUntil + 86400000;
                convertDateUntil = new Date(convertDateUntil)

                let first = db.collection("Ordenes")
                .where('createdOn', ">=", new Date(convertDateSince))
                .where('createdOn', '<=', new Date(convertDateUntil))
                .where('pais', '==', country)
                .orderBy('createdOn', 'desc')

                first.get().then((documentSnapshots) => {
                    const dataFetch = documentSnapshots.docs.map(doc => doc.data())

                    let newData = [];
                    let nextPage;
            
                    newData = dataFetch;

                    if (status) {
                        newData = newData.filter(newData => newData.status === status);

                        if (typeOrder) {
                            newData = newData.filter(newData => newData.tipoOrden === typeOrder);
                        };
                    } else if (typeOrder) {
                        newData = dataFetch.filter(dataFetch => dataFetch.tipoOrden === typeOrder)
                    }
                    if (page === '1') {
                        newData = newData.slice(0, 10);
                    } else {
                        nextPage = `${page}0`;
                        newData = newData.slice(parseInt(nextPage) - 10, parseInt(nextPage));
                    }
        
                    dispatch({ type: 'GET_ORDERS_FILTER', payload: { data: newData, first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1] } })
                })
                .catch(error => dispatch({ type: 'GET_ORDERS_FILTER_ERROR', payload: { code: 'orders/error', message: error } }))   
            } else {
                let first = db.collection("Ordenes")
                .where('uid', "!=", false)
                .where('pais', '==', country)

                first.get().then((documentSnapshots) => {
                    const dataFetch = documentSnapshots.docs.map(doc => doc.data())

                    let newData = [];
                    let nextPage;
            
                    if (status) {
                        newData = dataFetch.filter(dataFetch => dataFetch.status === status);
                        if (typeOrder) {
                            newData = newData.filter(newData => newData.tipoOrden === typeOrder)
                        }
                    } else if (typeOrder) {
                        newData = dataFetch.filter(dataFetch => dataFetch.tipoOrden === typeOrder)
                    }

                    if (page === '1') {
                        newData = newData.slice(0, 10);
                    } else {
                        nextPage = `${page}0`;
                        newData = newData.slice(parseInt(nextPage) - 10, parseInt(nextPage));
                    }
        
                    dispatch({ type: 'GET_ORDERS_FILTER', payload: { data: newData, first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1] } })
                })
                .catch(error => dispatch({ type: 'GET_ORDERS_FILTER_ERROR', payload: { code: 'orders/error', message: error } }))   
            };
        }
    }

    const getOrdersFilterExcel = (dateSince, dateUntil, status, typeOrder, country) => {
        dispatch({ type: 'GET_ORDERS_FILTER_EXCEL_LOADING' });

        if (!authenticatedState.user.pais || authenticatedState.user.role === "Administrador" || authenticatedState.user.role === "Operador") {
            getGlobalOrdersFilterExcel(dateSince, dateUntil, status, typeOrder, country);
        } else {
            getOrdersFilterPerCountryExcel(dateSince, dateUntil, status, typeOrder, authenticatedState.user.pais);
        }
    }

    const getGlobalOrdersFilterExcel = (dateSince, dateUntil, status, typeOrder, country) => {
        let db = firestoreInitialize();

        if (dateSince && dateUntil) {
            let convertDateSince = new Date(dateSince).getTime();
            convertDateSince = convertDateSince + 86400000;
            convertDateSince = new Date(convertDateSince).setHours(0);

            let convertDateUntil = new Date(dateUntil).getTime();
            convertDateUntil = convertDateUntil + 86400000;

            let first = db.collection("Ordenes")
            .where('createdOn', ">=", new Date(convertDateSince))
            .where('createdOn', '<=', new Date(convertDateUntil))
            .orderBy('createdOn', 'desc')

        first.get().then((documentSnapshots) => {
            let orders = documentSnapshots.docs.map(doc => doc.data())

            if (status) {
                orders = orders.filter(order => order.status === status);
            } 

            if (typeOrder) {
                orders = orders.filter(order => order.tipoOrden === typeOrder);
            };

            if (country) {
                orders = orders.filter(order => order.pais === country);
            }

            dispatch({ type: 'GET_ORDERS_FILTER_EXCEL', payload: { data: orders, first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1] } })
            })
            .catch(error => dispatch({ type: 'GET_ORDERS_FILTER_EXCEL_ERROR', payload: { code: 'orders/error', message: error } }))   
        } else {
            let first = db.collection("Ordenes")
                .orderBy('createdOn', 'desc')

            first.get().then((documentSnapshots) => {
                let orders = documentSnapshots.docs.map(doc => doc.data())
        
                if (status) {
                    orders = orders.filter(order => order.status === status);
                }

                if (typeOrder) {
                    orders = orders.filter(order => order.tipoOrden === typeOrder);
                };

                if (country) {
                    orders = orders.filter(order => order.pais === country);
                }

                dispatch({ type: 'GET_ORDERS_FILTER_EXCEL', payload: { data: orders, first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1] } })
            })
            .catch(error => dispatch({ type: 'GET_ORDERS_FILTER_EXCEL_ERROR', payload: { code: 'orders/error', message: error } }))   
        }
    };

    const getOrdersFilterPerCountryExcel = (dateSince, dateUntil, status, typeOrder, country) => {
        let db = firestoreInitialize();

        if (dateSince && dateUntil) {
            let convertDateSince = new Date(dateSince).getTime();
            convertDateSince = convertDateSince + 86400000;
            convertDateSince = new Date(convertDateSince).setHours(0);

            let convertDateUntil = new Date(dateUntil).getTime();
            convertDateUntil = convertDateUntil + 86400000;

            let first = db.collection("Ordenes")
            .where('createdOn', ">=", new Date(convertDateSince))
            .where('createdOn', '<=', new Date(convertDateUntil))
            .where('pais', '==', country)
            .orderBy('createdOn', 'desc')

        first.get().then((documentSnapshots) => {
            const dataFetch = documentSnapshots.docs.map(doc => doc.data())

            let newData = [];
            
            newData = dataFetch;

            if (status) {
                newData = newData.filter(newData => newData.status === status);

                if (typeOrder) {
                    newData = newData.filter(newData => newData.tipoOrden === typeOrder);
                };
            } else if (typeOrder) {
                newData = dataFetch.filter(dataFetch => dataFetch.tipoOrden === typeOrder)
            }

            dispatch({ type: 'GET_ORDERS_FILTER_EXCEL', payload: { data: newData, first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1] } })
            })
            .catch(error => dispatch({ type: 'GET_ORDERS_FILTER_EXCEL_ERROR', payload: { code: 'orders/error', message: error } }))   
        } else {
            let first = db.collection("Ordenes")
            .where('pais', '==', country)
            .orderBy('createdOn', 'desc')

            first.get().then((documentSnapshots) => {
                const dataFetch = documentSnapshots.docs.map(doc => doc.data())

                let newData = [];
        
                if (status) {
                    newData = dataFetch.filter(dataFetch => dataFetch.status === status);

                    if (typeOrder) {
                        newData = newData.filter(newData => newData.tipoOrden === typeOrder);
                    };
                } else if (typeOrder) {
                    newData = dataFetch.filter(dataFetch => dataFetch.tipoOrden === typeOrder)
                }
        
                dispatch({ type: 'GET_ORDERS_FILTER_EXCEL', payload: { data: newData, first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1] } })
            })
            .catch(error => dispatch({ type: 'GET_ORDERS_FILTER_EXCEL_ERROR', payload: { code: 'orders/error', message: error } }))   
        }
    }

    const getOrdersAllMonth = (country) => {
        dispatch({ type: 'GET_ORDERS_ALL_MONTH_LOADING' });

        if (country) {
            getOrdersAllMonthPerCountry(country);
        } else if (!authenticatedState.user.pais || authenticatedState.user.role === "Administrador" || authenticatedState.user.role === "Operador") {
            getGlobalOrdersAllMonth();
        } else {
            getOrdersAllMonthPerCountry(authenticatedState.user.pais);
        }
    };

    const getGlobalOrdersAllMonth = async () => {
        const year = new Date().getFullYear()

        let db = firestoreInitialize();

        let ordersPerMonth = [];

        for (let index = 1; index <= 12; index++) {
            let month;

            if (index < 10) {
                month = `0${index.toString()}`;
            } else {
                month = `${index.toString()}`;
            }

            let convertDateStart = new Date(`${year}-${month}-01`).setHours(0)

            let convertDate = new Date(convertDateStart);

            let startDate;
            let endDate;

            if (index === 1) {
                startDate = new Date(convertDate.getFullYear() + 1, convertDate.getMonth(), 1);
                endDate = new Date(convertDate.getFullYear() + 1, convertDate.getMonth() + 1, 0);
            } else {
                startDate = new Date(convertDate.getFullYear(), convertDate.getMonth(), 1);
                endDate = new Date(convertDate.getFullYear(), convertDate.getMonth() + 1, 0);
            }

            endDate = endDate.setHours(23,59,59,999)

            await db.collection('Ordenes')
            .where('createdOn', '>=', new Date(startDate))
            .where('createdOn', '<=', new Date(endDate))
            .get()
            .then((documentSnapshots) => {
                ordersPerMonth.push(documentSnapshots.docs.map(doc => doc.data()))
            })
        }

        dispatch({ type: 'GET_ORDERS_ALL_MONTH', payload: { data: ordersPerMonth } });
    }

    const getOrdersAllMonthPerCountry = async (country) => {
        const year = new Date().getFullYear()

        let db = firestoreInitialize();

        let ordersPerMonth = [];

        for (let index = 1; index <= 12; index++) {
            let month;

            if (index < 10) {
                month = `0${index.toString()}`;
            } else {
                month = `${index.toString()}`;
            }

            let convertDateStart = new Date(`${year}-${month}-01`).setHours(0)

            let convertDate = new Date(convertDateStart);

            let startDate;
            let endDate;

            if (index === 1) {
                startDate = new Date(convertDate.getFullYear() + 1, convertDate.getMonth(), 1);
                endDate = new Date(convertDate.getFullYear() + 1, convertDate.getMonth() + 1, 0);
            } else {
                startDate = new Date(convertDate.getFullYear(), convertDate.getMonth(), 1);
                endDate = new Date(convertDate.getFullYear(), convertDate.getMonth() + 1, 0);
            }

            endDate = endDate.setHours(23,59,59,999)

            await db.collection('Ordenes')
            .where('createdOn', '>=', new Date(startDate))
            .where('createdOn', '<=', new Date(endDate))
            .get()
            .then((documentSnapshots) => {
                let data = documentSnapshots.docs.map(doc => doc.data());
                data = data.filter(data => data.pais === country);
                
                ordersPerMonth.push(data);
            })
        }

        dispatch({ type: 'GET_ORDERS_ALL_MONTH', payload: { data: ordersPerMonth } });
    }

    const resetOrdersState = () => {
        dispatch({ type: 'ORDERS_RESET_STATE' });
    };

    const resetOrdersExcelState = () => {
        dispatch({ type: 'ORDERS_EXCEL_RESET_STATE' });
    };

    return (
        <OrdersContext.Provider value={{
            ordersState: state.getOrders,
            ordersAllMonthState: state.getOrdersAllMonth,
            ordersByIdState: state.getOrdersById,
            ordersExcelState: state.getOrdersExcel,
            getOrders,
            getOrdersById,
            getOrdersPerMonth,
            getOrdersPerDate,
            getOrdersFilter,
            getOrdersExcel,
            getOrdersFilterExcel,
            getOrdersAllMonth,
            resetOrdersState,
            resetOrdersExcelState,
        }}>
            {props.children}
        </OrdersContext.Provider>
    )
}

export default OrdersState;
